import React from 'react'
import { Button as AntdButton, theme } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const withCustomProps = WrappedComponent => {
    return ({ color, ...otherProps }) => {
        const { token: themeToken } = theme.useToken()

        let customStyle = {}
        let customIcon = otherProps.icon

        if (color === 'success') {
            customStyle = {
                color: themeToken.colorSuccess,
            }
            customIcon = customIcon || <CheckOutlined />
        } else if (color === 'error') {
            customStyle = {
                color: themeToken.colorError,
            }
            customIcon = customIcon || <CloseOutlined />
        }

        if (otherProps.disabled)
            customStyle = {
                backgroundColor: themeToken.colorBgDisabled,
                color: themeToken.colorTextDisabled,
            }

        return <WrappedComponent {...otherProps} style={{ ...otherProps.style, ...customStyle }} icon={customIcon} />
    }
}

const Button = withCustomProps(AntdButton)
export default Button
